import _getIterator from 'babel-runtime/core-js/get-iterator';
import _extends from 'babel-runtime/helpers/extends';

import AdvertisersFilter from './advertisers-filter.vue';
import SubmitConfirmation from './submit-confirmation.vue';
import { format } from 'date-fns';
import _ from 'lodash';

var defaultFormValue = {
  is_hand_filter: true,
  adv_names: '',
  is_all_creative_types: true,
  creative_types: [],
  is_all_app_tags: true,
  app_tags: [],
  is_all_project_tags: true,
  project_tags: [],
  start_time: '',
  is_long_push: true,
  end_time: ''
};

export default {
  components: { AdvertisersFilter: AdvertisersFilter, SubmitConfirmation: SubmitConfirmation },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    batchAdvNames: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    appTagList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    projectTagList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      noAdvertisersTips: false,
      creativeType: [{
        value: 1,
        label: 'graphic'
      }, {
        value: 2,
        label: 'video'
      }, {
        value: 3,
        label: 'playable'
      }],
      formValue: _extends({}, defaultFormValue),
      advertisersFilterArray: '',
      submitDialog: {
        visible: false,
        formValue: {}
      }
    };
  },

  computed: {
    defaultProps: function defaultProps() {
      return {
        children: 'child',
        emitPath: false,
        label: 'name',
        value: 'code',
        multiple: true
      };
    },
    rules: function rules() {
      var _this = this;

      return {
        creative_types: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formValue.is_all_creative_types) {
              callback();
            } else if (value.length === 0) {
              callback(new Error('请选择素材类型'));
            } else {
              callback();
            }
          }
        }],
        app_tags: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formValue.is_all_app_tags) {
              callback();
            } else if (value.length === 0) {
              callback(new Error('请选择产品分类'));
            } else {
              callback();
            }
          }
        }],
        project_tags: [{
          required: true,
          trigger: 'blur',
          validator: function validator(rule, value, callback) {
            if (_this.formValue.is_all_project_tags) {
              callback();
            } else if (value.length === 0) {
              callback(new Error('请选择运营分类'));
            } else {
              callback();
            }
          }
        }]
      };
    },
    formItemList: function formItemList() {
      return {
        start_time: {
          label: '执行开始时间',
          prop: 'start_time',
          rules: [{
            required: true,
            message: '请选择执行开始时间',
            trigger: 'change'
          }, {
            validator: this.validatorTime,
            trigger: 'change'
          }],
          params: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            placeholder: '执行开始时间',
            clearable: true,
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
              }
            }
          }
        },
        end_time: {
          label: '执行结束时间',
          prop: 'end_time',
          rules: [{
            validator: this.validatorNull,
            trigger: 'change'
          }],
          params: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd',
            placeholder: '执行结束时间',
            clearable: true,
            disabled: this.formValue.is_long_push,
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
              }
            }
          }
        }
      };
    },
    submitDisabled: function submitDisabled() {
      if (this.formValue.is_hand_filter) {
        return !this.formValue.adv_names;
      }
      return !this.advertisersFilterArray;
    }
  },
  methods: {
    validatorTime: function validatorTime(rule, value, callback) {
      var start_time = new Date(this.formValue.start_time);
      var end_time = new Date(this.formValue.end_time);

      if (start_time && end_time) {
        if (start_time.getTime() > end_time.getTime()) {
          callback(new Error('开始时间必须小于结束时间'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    validatorNull: function validatorNull(rule, value, callback) {
      var end_time = new Date(this.formValue.end_time).getTime();
      if (!this.formValue.is_long_push && isNaN(end_time)) {
        callback(new Error('请选择结束时间'));
      } else {
        callback();
      }
    },
    getAdvName: function getAdvName(array) {
      this.advertisersFilterArray = array.join();
      this.noAdvertisersTips = !this.advertisersFilterArray;
    },
    handleClose: function handleClose() {
      if (!this.loading) {
        this.$emit('update:visible', false);
      }
    },
    handleRefresh: function handleRefresh() {
      this.handleClose();
      this.$emit('handleRefresh');
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      this.$refs.planForm && this.$refs.planForm.validate(function (valid) {
        if (valid) {
          _this2.submitDialog.visible = true;

          _this2.submitDialog.formValue = {
            adv_names: _this2.formValue.is_hand_filter ? _this2.formValue.adv_names.replace(/，/g, ',') : _this2.advertisersFilterArray.replace(/，/g, ','),

            creative_types: _this2.formValue.is_all_creative_types ? '全部' : _this2.creativeType.filter(function (item) {
              return _this2.formValue.creative_types.includes(item.value);
            }).map(function (t) {
              return t.label;
            }).join(),

            app_tags: _this2.formValue.app_tags,
            app_tags_label: _this2.formValue.is_all_app_tags ? '全部' : _this2.getTagLabel(_this2.appTagList, _this2.formValue.app_tags, 3),

            project_tags: _this2.formValue.project_tags,
            project_tags_label: _this2.formValue.is_all_project_tags ? '全部' : _this2.getTagLabel(_this2.projectTagList, _this2.formValue.project_tags, 2),

            start_time: format(_this2.formValue.start_time, 'YYYY-MM-DD'),
            end_time: _this2.formValue.is_long_push ? 0 : format(_this2.formValue.end_time, 'YYYY-MM-DD')
          };
        }
      });
    },
    getTagLabel: function getTagLabel(array, value, levels) {
      var labelAll = [];

      var _loop = function _loop(item) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _getIterator(array), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var v = _step2.value;

            if (v.child) {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = _getIterator(v.child), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var s = _step3.value;

                  var childName = '';
                  // eslint-disable-next-line max-depth
                  if (levels === 3) {
                    childName = (s.child.find(function (t) {
                      return Number(item) === t.code;
                    }) || {}).name;
                    // eslint-disable-next-line max-depth
                    if (childName) {
                      labelAll.push('' + childName);
                    }
                  } else {
                    childName = Number(item) === s.code ? s.name : '';
                    // eslint-disable-next-line max-depth
                    if (childName) {
                      labelAll.push('' + childName);
                    }
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            } else {
              if (Number(item) === v.code) {
                labelAll.push(v.name);
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = _getIterator(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          _loop(item);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return labelAll.toString();
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        if (this.type === 'batch' && this.batchAdvNames.length) {
          this.formValue.adv_names = this.batchAdvNames.toString();
        }
      } else {
        this.noAdvertisersTips = false;
        this.advertisersFilterArray = '';
        this.$refs.planForm && this.$refs.planForm.resetFields();

        if (this.$refs.advertisersFilter) {
          this.$refs.advertisersFilter.$refs['filter-form'].resetFields();
          this.$refs.advertisersFilter.handleReset();
        }

        this.formValue = _.cloneDeep(defaultFormValue);
      }
    }
  }
};